import api from '../api'


export function fetchIntegrations() {
	return (dispatch) => api.fetch('/integrations')
		.then((response) => {
			dispatch({ type: 'FETCH_INTEGRATIONS_SUCCESS', response })
			return response

		})
		.catch((error) => {
			//return error
		})
	   

}

export function fetchIntegrationSections(integrationId) {
	return (dispatch) => api.fetch(`/integrations/${integrationId}/sections`)
		.then((response) => {
			return response
		})
		.catch((error) => {
			if(window.analytics){
				const errorCode=error.response.status
				window.analytics.track('Fetch integration sections error',{error:error,errorCode:errorCode})
			}
			//return error
		})
}


export function upsertIntegration(data) {
  	return (dispatch) => api.put('/integrations',data)
	    .then((integration) => {
		      return integration
	    })
	   	.catch((error) => {

		})
}


